import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useQParam } from "../../../components/hooks/useQParam";
import { Button } from "../../elements/Button";
import { SuccessIcon } from "../../icons/truWeb-icons";
import "./style.scss";

export const ThankYouPage = ({
  onReturnBack,
  isSchemaLoading,
  options,
}: any) => {
  const thankyouId = useQParam("thank-you");
  const location = useLocation();
  const [loading, setIsLoading] = useState(isSchemaLoading);

  useEffect(() => {
    setIsLoading(isSchemaLoading);
  }, [isSchemaLoading]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!thankyouId) return null;

  if (loading) {
    return (
      <div className="tru-list-loading">
        <span className="loading-anim"></span>
      </div>
    );
  }

  return (
    <div className="thank-wrapper text-center t-primary-content__content-column t-content-column--wysiwyg  t-content-column--12  t-content-column--padding-top-default  t-content-column--padding-bottom-default ">
      <div className="t-content-column__inner">
        <SuccessIcon />
        <h2> {options?.thankyouLabel} </h2>
        <p style={{ textAlign: "center" }}>
          <>
            {location?.state && location?.state!}
            {!location?.state && "Thank You!"}
          </>
        </p>
        {thankyouId !== "success" && (
          <Button
            classes="t-button white t-button__large t-button__primary"
            onClick={onReturnBack}
          >
            {options?.thankyouButtonLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
